import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Spinner, Alert } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './EmbroideryDesigns.css';

const EmbroideryDesigns = () => {
  const [designs, setDesigns] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    fetchDesigns();
  }, []);

  const fetchDesigns = async () => {
    try {
      const response = await axios.get('https://madhusewingmachines.com/api/embroidery-designs');
      if (response.data.success) {
        setDesigns(response.data.designs);
      }
    } catch (error) {
      console.error('Error fetching designs:', error);
      setError('Failed to load embroidery designs');
    } finally {
      setLoading(false);
    }
  };

  const handleDesignClick = (designId) => {
    navigate(`/embroidery-design/${designId}`);
  };

  if (loading) {
    return (
      <Container className="text-center py-5" style={{ marginTop: '100px' }}>
        <Spinner animation="border" />
        <p className="mt-3">Loading designs...</p>
      </Container>
    );
  }

  if (error) {
    return (
      <Container style={{ marginTop: '100px' }}>
        <Alert variant="danger">{error}</Alert>
      </Container>
    );
  }

  return (
    <Container className="embroidery-designs-container" style={{ marginTop: '100px', marginBottom: '50px' }}>
      <h2 className="text-center mb-4">Embroidery Designs</h2>
      
      {designs.length === 0 ? (
        <Alert variant="info" className="text-center">
          No embroidery designs available at the moment.
        </Alert>
      ) : (
        <Row>
          {designs.map((design) => (
            <Col key={design._id} xs={12} sm={6} md={4} lg={3} className="mb-4">
              <Card 
                className="design-card h-100 shadow-sm"
                onClick={() => handleDesignClick(design._id)}
                style={{ cursor: 'pointer' }}
              >
                <div className="design-image-container position-relative">
                  {design.images && design.images.length > 0 ? (
                    <Card.Img
                      variant="top"
                      src={`https://madhusewingmachines.com/uploads/${design.images[0].url}`}
                      alt={design.name}
                      className="design-image"
                    />
                  ) : (
                    <div className="no-image-placeholder">
                      <span>No Image</span>
                    </div>
                  )}
                  {design.isNew && (
                    <span className="badge bg-danger position-absolute top-0 start-0 m-2">
                      NEW
                    </span>
                  )}
                  {design.discount && (
                    <span className="badge bg-success position-absolute top-0 end-0 m-2">
                      {design.discount}
                    </span>
                  )}
                </div>
                
                <Card.Body>
                  <Card.Title className="design-code">{design.designCode}</Card.Title>
                  <Card.Text className="design-name text-muted small">
                    {design.name}
                  </Card.Text>
                  
                  {design.dimensions && (
                    <div className="design-dimensions small text-muted mb-2">
                      <span>Height: {design.dimensions.height}</span>
                      <span className="ms-2">Width: {design.dimensions.width}</span>
                    </div>
                  )}
                  
                  {design.stitchDetails && (
                    <div className="stitch-count small text-muted mb-2">
                      Stitches: {design.stitchDetails.count}
                    </div>
                  )}
                  
                  <div className="price-section mt-2">
                    {design.compatibleMachines && design.compatibleMachines.length > 0 ? (
                      <>
                        <span className="current-price fw-bold text-success">
                          From ₹{Math.min(...design.compatibleMachines.map(m => m.price))}
                        </span>
                        {design.discount && (
                          <span className="badge bg-success ms-2">{design.discount}</span>
                        )}
                      </>
                    ) : (
                      <span className="text-muted small">Price varies by machine</span>
                    )}
                  </div>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      )}
    </Container>
  );
};

export default EmbroideryDesigns;
